import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { LoginPayload } from '../models/login-payload.model';
import { AuthResult } from '../models/auth-result.model';

@Injectable({
  providedIn: 'root',
})
export class AuthHttpService {
  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  loginUser(authData: LoginPayload): Observable<AuthResult> {
    return this.http.post<AuthResult>(
      `${this.baseUrl}externalportal/login`,
      JSON.stringify(authData)
    );
  }

  loginByNonceId(id: string): Observable<AuthResult> {
    return this.http.post<AuthResult>(
      `${this.baseUrl}externalportal/login/nonce`,
      JSON.stringify({ nonceId: id })
    );
  }
}
